import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const OrganizationNotFoundError = BaseErrorSchema.extend({
  errorType: z.literal('OrganizationNotFoundError'),
  id: z.string(),
});

export type OrganizationNotFoundError = z.infer<
  typeof OrganizationNotFoundError
>;
